import React from 'react';
const VALUE_PROPS = [{
  top: 'Prescribed by',
  bottom: 'board-certified physicians'
}, {
  top: 'Made custom',
  bottom: 'for your body'
}, {
  top: 'Free',
  bottom: 'shipping, always'
}, {
  top: 'Unlimited follow-ups',
  bottom: 'with your care team'
}, {
  top: 'Pause or cancel',
  bottom: 'anytime'
}];
export function Marquee() {
  // Duplicate the array once to create a seamless loop
  const items = [...VALUE_PROPS, ...VALUE_PROPS];
  return <div className="w-full bg-orla-sienna h-[80px] overflow-hidden flex items-center relative" data-id="element-242">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused] items-center" data-id="element-243">
        {items.map((prop, index) => <div key={index} className="flex items-center flex-shrink-0" data-id="element-244">
            <div className="flex flex-col justify-center px-8 md:px-12" data-id="element-245">
              <span className="font-body font-semibold text-[15px] text-orla-bone whitespace-nowrap" data-id="element-246">
                {prop.top}
              </span>
              <span className="font-body font-normal text-[14px] text-orla-bone/80 whitespace-nowrap" data-id="element-247">
                {prop.bottom}
              </span>
            </div>
            {/* Divider */}
            <div className="text-orla-saffron text-xs select-none" aria-hidden="true" data-id="element-248">
              ♦
            </div>
          </div>)}
      </div>
    </div>;
}